import { Link as MuiLink } from "@mui/material";
import { LabelValueForText } from "components/ui/atoms/LabelValue";
import { Link } from "react-router-dom";

import ApartmentIcon from "@mui/icons-material/Apartment";
import Box from "@mui/material/Box";
import { useMemo } from "react";
import { getCommons } from "./fieldConverterHelpers";

export const LogoCell = ({ value }) => {
  const Logo = useMemo(() => {
    if (!value) return ApartmentIcon;
    return () => (
      <img
        loading="lazy"
        src={value.url}
        alt="Logo"
        style={{
          maxWidth: 60,
          maxHeight: 32,
          width: "auto",
          height: "auto",
          display: "block",
          backgroundColor: "transparent",
        }}
      />
    );
  }, [value]);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100%"
    >
      <Logo />
    </Box>
  );
};

export const LogoFieldView = ({ field, value }) => {
  return (
    <LabelValueForText
      label={field.label}
      value={
        <MuiLink
          component={Link}
          underline="hover"
          color="inherit"
          to={value?.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {value && (
            <img
              loading="lazy"
              src={value.url}
              alt="Logo"
              style={{
                maxWidth: 60,
                maxHeight: 32,
                width: "auto",
                height: "auto",
                display: "block",
                backgroundColor: "transparent",
              }}
            />
          )}
        </MuiLink>
      }
      sx={{ display: field.hidden ? "none" : "inherit" }}
      isMissing={!value}
    />
  );
};

export const logoFieldConverter = ({ field }) => {
  return {
    ...getCommons({ field }),
    type: "string",
    width: field.width || 72,
    renderCell: LogoCell,
  };
};
